import {
  Component,
  OnInit,
  Input,
  ViewChildren,
  QueryList
} from '@angular/core';
import {
    CleanersService
} from '../../../injections/cleaners.service';
import {
    AvailabilityService
} from '../../../injections/availability.service';
import {PredictiveComponent} from "../../../common/predictive/predictive.component";

import { Router,ActivatedRoute } from "@angular/router";


@Component({
  moduleId: module.id,
  selector: 'main-availability',
  templateUrl: '../templates/detail-availability.html',
  providers: [],
})

export class DetailAvailabilityComponent implements OnInit {

  public availability: Array < object > ;
  public searchCleaners: boolean = false;
  public searchValue;
  public idCleaner;
  @ViewChildren(PredictiveComponent) predictives: QueryList<PredictiveComponent>;

  constructor(private cleanersService: CleanersService, private availabilityService: AvailabilityService, private route: ActivatedRoute) {

    this.route.params.subscribe(params => {
        if(params["id"]){
            this.availabilityService.getAvailabilityCleaner(params["id"]).subscribe(result => {
                this.availability = result;
                //console.log(result);
                this.searchValue = result["cleanerName"];
          });
        }
      });
  }
  
  public emptyPredictiveArray(type){
    this.predictives.forEach((item) => {
        if(type != item.type){
          item.items = [];
          item.inputValue = null;
        }else{
          if(item.inputValue != ''){
            this.setPredictive(item);
          }else{
            item.items = [];
          }
        }
    });    
  }


  public itemSelected(value) {
      //console.log(value);
      this.searchValue = value["value"];
      this.availabilityService.getAvailabilityCleaner(value["id"]).subscribe(result => {
            this.availability = result;
      });
  }

  private setPredictive(predictive: PredictiveComponent) {
    switch (predictive.type) {
      case 'cleaner':
        this.cleanersService.findCleanerByName(predictive.inputValue).distinctUntilChanged()
          .debounceTime(1000)
          .subscribe(result => {
            if (result instanceof Array) {
              predictive.items = result;
            } else {
              predictive.items = [];
            }
          });
        break;
    }
  }

  ngOnInit() {
    //this.availability = this.availabilityService.getAvailabilityDetail();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/availability/components/detail-availability.component.ts